const mapStateToProps = (state)=>{
    // const geoObjs = state?.api?.geoObjs;
    // const getGeoObj = state?.service?.Api?.getGeoObj;
    // const selectedGeoObjArray = state?.ui?.selectedGeoObjArray;
    const {

        api:{
            geoObjGeozone,
            getGeozoneIntersections
        }={},
        geozone:{
            geozoneArr,
            geozoneSettingsArr,
        }={},
        service:{
            Geozone:{
                loadGeozone,
                updateGeozoneSettingsArr,
            }={}
        }={}
    } = state;
    return {
        geoObjGeozone,
        geozoneArr,
        geozoneSettingsArr,

        loadGeozone,
        updateGeozoneSettingsArr,
        getGeozoneIntersections
    }
}

export default mapStateToProps